import request from '@/utils/request'

//获取直播
export function getLiveList(data) {
	return request({
		url: '/api/live/getLiveList',
		method: 'get',
		params: data
	})
}

//获取聊天室组id
export function joinRoomById (data) {
  return request({
    url: '/api/live/joinRoomById',
    method: 'post',
    data
  })
}

//查询回放视频
export function selectPlayBackVideo(data) {
	return request({
		url: '/api/playBack/selectPlayBackVideo',
		method: 'get',
		params: data
	})
}
